
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Renderer2,
  ViewChild,
  ViewContainerRef,
  AfterViewInit,
  QueryList,
  DOCUMENT
} from '@angular/core';
import {
  FormGroup,
  Validators,
  FormBuilder,
  ValidatorFn,
  FormControl,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { Router } from '@angular/router';
import { PaymentService } from '@core/payments/services/payment.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from '@shared/services/loader.service';
import { TransactionService } from '@shared/services/transaction.service';
import { getValidationConfigFromCardNo } from 'src/app/helpers/card.helper';
import { luhnValidator } from 'src/app/validators/luhnValidator';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
import { EnableModulesService } from '@shared/services/enable-modules.service';
import { Subscription } from 'rxjs';
import { LabelService } from '@core/payments/services/label.service';
declare var $: any;
declare var Flex: any;

@Component({
    selector: 'app-payment-page',
    templateUrl: './payment-page.component.html',
    styleUrls: ['./payment-page.component.css'],
    standalone: false
})
export class PaymentPageComponent implements AfterViewInit {
  @ViewChild('iframe') iframe!: ElementRef;
  public uploadcard: boolean = false;
  public numbermodule: number = 0;
  formPayment: FormGroup;
  textoSinFormato: any;
  dueInitial: number = 1;
  cardType: any = '';
  formValid = false;
  isButtonEnabled = false;
  buttonClass = '';
  backgroundImg = '';
  infoClass = '';
  cvvClass = 'noshow';
  cardInfoNumber: string = '';
  cardInfoExpire: string = '';
  cardInfoName: string = '';
  cvv: string = '';
  saveCard: boolean = false;
  franchise: string = '';
  idSessionToken: string = '';
  cardinalAction: string = '';
  referenceId: string = '';
  jwtCardinal: string = '';
  successCollectionCardinal = false;
  count: number = 10;
  iframeAuthContent: any = '';
  flexSrc = environment.microform_src;
  canEnrAutPay = localStorage.getItem('canEnrAutPay');
  canRegCard = localStorage.getItem('canRegCard');
  afiliateCard: boolean = false;
  private microform: any;
  private timeOutCentinel = false;
  private iframeChallengeWidth: string = '';
  private iframeChallengeHeight: number = 0;
  private transientToken: string = '';
  private token: string = '';
  private cardBin: string = '';
  private expirationDate: string = '';
  binCard: string = '';
  cardExpirationDate: string = '';
  formattedMaskedValue: string = '';
  onlyLinkAutomaticDebit: boolean = false;
  emailForDom: string = '';
  isDarkMode: boolean = false;
  changeLabels: boolean = false;
  channel: number = 0;
  currentLanguage: 'es' | 'en' = 'es';
  private confirmed: boolean = false;

  public listObservers$: Array<Subscription> = [];
  public transactionIsFinalized: boolean = false;

  @ViewChild('cardinalForm') cardinalForm!: ElementRef<HTMLFormElement>;
  private modalRef!: NgbModalRef;

  constructor(
    private fb: FormBuilder,
    private LabelService: LabelService,
    public _paymentService: PaymentService,
    private _transactionService: TransactionService,
    private router: Router,
    private _loaderService: LoaderService,
    @Inject(DOCUMENT) private _document: Document,
    private element: ElementRef,
    private _renderer2: Renderer2,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private moduleService: EnableModulesService,
    ) {
    this.emailForDom =
      this._paymentService.payerEmail || this._paymentService.emailFromDom;
    this.formPayment = this.fb.group({
      expirationDate: [
        '',
        [Validators.required, Validators.minLength(5), this.DateValidator()],
      ],
      emailAddress: [
        this.emailForDom ? this.emailForDom : '',
        localStorage.getItem('channel') !== '6'
          ? [
            Validators.required,
            Validators.pattern(/^[a-z0-9](?!.*[._%+-]{2})[a-z0-9._%+-]*[a-z0-9]@[a-z0-9-]+(?:\.[a-z0-9-]+)*\.[a-z]{2,}$/),
            this.emailDomainValidator().bind(this),
          ]
          : []
      ],
      isLinked: [false, Validators.required],
      aceptarterminos: [true, Validators.required],
      afiliartarjeta: [this.onlyLinkAutomaticDebit],
    });
  }

  ngAfterViewInit(): void {
    $('[data-toggle="tooltip"]').tooltip();
    const expirationTime = environment.transactionExpirationTime * 60 * 1000;
    setTimeout(() => {
      this.expireTransaction();
    }, expirationTime);
  }

  ngOnInit(): void {
    this.initializeDarkMode();
    const onlyLinkAutomaticDebit = localStorage.getItem(
      'onlyLinkAutomaticDebit'
    );
    this.onlyLinkAutomaticDebit =
      onlyLinkAutomaticDebit == 'true' || this._paymentService.uploadcard
        ? true
        : false;
    this.formPayment.controls['afiliartarjeta'].setValue(
      this.onlyLinkAutomaticDebit
    );
    this.addFingerPrintScript();
    this.initMicroform();

    this.formPayment.valueChanges.subscribe(() => {
      this.formValid = false;
      this.isButtonEnabled = false;
      if (this.formPayment.valid && this.formPayment.value.aceptarterminos) {
        this.formValid = true;
        this.isButtonEnabled = true;
      }
      this.buttonClass = this.isButtonEnabled
        ? 'btnPrimary'
        : 'btnPrimaryDisabled';
    });
  }

  ngOnDestroy() {
    window.removeEventListener(
      'message',
      this.dataCollectionResponseCardinal.bind(this)
    );
    this.listObservers$.forEach((o) => o.unsubscribe());
  }

  sendFormCP(): void {
    const bodyRequest = this.formPayment.value;

    if (this.onlyLinkAutomaticDebit === true) {
      bodyRequest.afiliartarjeta = this.onlyLinkAutomaticDebit;
    }

    bodyRequest.idSession = this.idSessionToken;
    bodyRequest.franchise = this.cardType;
    this._loaderService.blockLoading();
    const expirationDate = bodyRequest.expirationDate.split('/');

    const options = {
      expirationMonth: expirationDate[0],
      expirationYear: '20' + expirationDate[1],
    };
    this.microform.createToken(options, (err: any, token: string) => {
      if (err) {
        // handle error
      } else {
        this.transientToken = token;
        this._paymentService.tokencard = token;
        // At this point you may pass the token back to your server as you wish.
        // In this example we append a hidden input to the form and submit it.
        const decodedPayload = this.decodeToken(token);

        this.cardBin =
          decodedPayload.content.paymentInformation.card.number.bin;
        this.expirationDate =
          decodedPayload.content.paymentInformation.card.expirationMonth.value +
          '/' +
          decodedPayload.content.paymentInformation.card.expirationYear.value;
        this.formattedMaskedValue = this.formatMaskedValue(
          decodedPayload.content.paymentInformation.card.number.maskedValue,
          this.cardBin
        );
        this._paymentService.bindcardgen = this.formattedMaskedValue;
        this._paymentService.expiratesdatecard = this.expirationDate;
        this._paymentService.email = bodyRequest.emailAddress;
        bodyRequest.transientToken = token;
        bodyRequest.captureContext = localStorage.getItem('captureContext');
        this._paymentService.bodyrequestcard = bodyRequest;
        //this.binCard = this.formattedMaskedValue;
        //this.cardExpirationDate = this.expirationDate;
        this._paymentService.afilcard = false;
        if (bodyRequest.afiliartarjeta) {
          this._paymentService.afilcard = true;
        }
        this._paymentService.numbermodule = 1;
      }
    });
  }

  sendPaymentForm(bodyRequest?: any): any {
    return new Promise((resolve, reject) => {
      this._paymentService.cardPayment(bodyRequest).subscribe(
        (transactionSummary) => {
          const { resultCode, result } = transactionSummary;
          this._paymentService.setIsNational(result.isNational);
          if (resultCode === 'REVIEW') {
            this.init3ds(result);
            const observer$: Subscription =
              this._paymentService.callback.subscribe(
                (transactionSummaryAfter3ds: any) => {
                  resolve(transactionSummaryAfter3ds);
                }
              );
            this.listObservers$ = [observer$];
          } else {
            resolve(transactionSummary);
          }
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  justNumbersDate(event: any) {
    // Eliminar todos los caracteres que no sean números ni "/"
    const inputValue = event.target.value;
    const numbersAndSlashOnly = inputValue.replace(/[^0-9/]/g, '');
    event.target.value = numbersAndSlashOnly;
  }

  dateFormat(value: any) {
    if (!isNaN(value.value) && value.value !== null) {
      const formattedDate = value.value.replace(/\D/g, '');
      if (formattedDate.length > 2) {
        const month = formattedDate.substring(0, 2);
        const year = formattedDate.substring(2);
        this.formPayment.controls['expirationDate'].setValue(
          `${month}/${year}`
        );
      }
    }
  }

  public DateValidator(): ValidatorFn {
    return () => {
      const expirationDateVar = this.formPayment?.get('expirationDate')?.value;
      if (!expirationDateVar) {
        // expirationDateVar es indefinida o nula
        return null; // O devuelve un error personalizado si es necesario
      }
      const arrayDate = expirationDateVar.split('/');
      const currentYear: any = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;
      const month = arrayDate[0];
      const year = arrayDate[1];
      if (isNaN(month) || isNaN(year)) {
        return { isValid: true };
      }
      if (parseInt(month) > 12) {
        return { isValid: true };
      }
      if (parseInt(year) < currentYear.toString().substr(2, 4)) {
        return { isValid: true };
      }
      if (parseInt(year) == currentYear.toString().substr(2, 4)) {
        if (parseInt(month) < currentMonth) {
          return { isValid: true };
        }
      }
      return null;
    };
  }

  /**
   * Integra seguimiento de transacciones con script de t1.
   */
  addFingerPrintScript() {
    // SCRIPT FINGERPRINT
    const randomBytes = new Uint8Array(15);
    const rerollBytes = crypto.getRandomValues(randomBytes);
    this.idSessionToken = this.bytesToHex(rerollBytes);
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src =
      environment.t1_fingerscript_src +
      '?org_id=' +
      environment.t1_orgid_dfp +
      '&session_id=' +
      localStorage.getItem('t1_merchant_id') +
      this.idSessionToken;

    this._renderer2.appendChild(this._document.head, script);

    //IFRAME FINGERPRINT
    let noscript = this._renderer2.createElement('noscript');
    let iframeT1 = this._renderer2.createElement('iframe');
    iframeT1.src =
      environment.t1_fingerscript_src +
      '?org_id=' +
      environment.t1_orgid_dfp +
      '&session_id=' +
      localStorage.getItem('t1_merchant_id') +
      this.idSessionToken;
    iframeT1.style =
      'width: 100px; height: 100px; border: 0; position:absolute; top: -5000px;';
    this._renderer2.appendChild(noscript, iframeT1);
    this._renderer2.appendChild(this._document.body, noscript);
  }

  private bytesToHex(bytes: Uint8Array): string {
    return Array.from(bytes)
      .map((byte) => byte.toString(16).padStart(2, '0'))
      .join('');
  }

  private init3ds(result: any) {
    const { jwtAuth, actionCardinal, referenceId } = result;

    this.jwtCardinal = jwtAuth;
    this.cardinalAction = actionCardinal;
    this.referenceId = referenceId;
    
    this.cdr.detectChanges();
    window.addEventListener(
      'message',
      this.dataCollectionResponseCardinal.bind(this)
    );
    if (this.cardinalForm && this.cardinalForm.nativeElement) {
      this.cardinalForm.nativeElement.submit();

      //sigue el flujo normal si no hay respuesta de cardinal en x segundos
      setTimeout(() => {
        if (!this.successCollectionCardinal) {
          this.timeOutCentinel = true;
          this.payerAuthenticationEnroll(); // sin perfilamiento
        }
      }, 10000); // esperar 10 segundos
    }
  }

  private dataCollectionResponseCardinal(event: MessageEvent) {
    if (event.origin === environment.centinel_domain) {
      const { MessageType, Status } = JSON.parse(event.data);
      if (
        MessageType == 'profile.completed' &&
        Status &&
        !this.timeOutCentinel
      ) {
        this.successCollectionCardinal = true;
        this.payerAuthenticationEnroll();
      }
    } else if (event.origin === environment.callback) {
      this.continuePaymentAuth();
    }
  }

  payerAuthenticationEnroll() {
    const bodyRequest = this._paymentService.bodyrequestcard;
    const now = new Date();
    const timeDifference = now.getTimezoneOffset();
    bodyRequest.centinelCollection = true;
    bodyRequest.idSession = this.referenceId;
    bodyRequest.deviceInformation = {
      httpBrowserColorDepth: screen.colorDepth,
      httpBrowserJavaEnabled: false,
      httpBrowserJavaScriptEnabled: true,
      httpBrowserLanguage: navigator.language,
      httpBrowserScreenHeight: screen.height,
      httpBrowserScreenWidth: screen.width,
      httpBrowserTimeDifference: timeDifference,
      userAgentBrowserValue: navigator.userAgent,
    };
    bodyRequest.transientToken = this.transientToken;
    bodyRequest.captureContext = localStorage.getItem('captureContext');
    this._paymentService
      .enrollPendingAuth(bodyRequest)
      .subscribe((transactionSummary) => {
        const { resultCode, result } = transactionSummary;
        if (resultCode === 'PENDING_REVIEW') {
          this.startStepUpAuth(result);
        } else {
          this._loaderService.unBlockLoaging();
          this._paymentService.callback.emit(transactionSummary);
        }
      });
  }

  private startStepUpAuth(result: any) {
    const { jwtAuth, stepUpUrl, windowSize } = result;
    const iframeSice = this.getIframeSize(windowSize);
    this.jwtCardinal = jwtAuth;
    this.buildIframeStepUp(jwtAuth, stepUpUrl);
  }

  private getIframeSize(windowSize: string) {
    switch (windowSize) {
      case '01':
        this.iframeChallengeWidth = '100%';
        this.iframeChallengeHeight = 600;
        break;
      case '02':
        this.iframeChallengeWidth = '100%';
        this.iframeChallengeHeight = 600;
        break;
      case '03':
        this.iframeChallengeWidth = '100%';
        this.iframeChallengeHeight = 600;
        break;
      case '04':
        this.iframeChallengeWidth = '100%';
        this.iframeChallengeHeight = 600;
        break;
      case '05':
      default:
        this.iframeChallengeWidth = '100%';
        this.iframeChallengeHeight = 1920;
        break;
    }
  }

  private buildIframeStepUp(jwtAuth: string, stepUpUrl: string) {
    //this.modalRef = this.modalService.open(this.modalAuth, { centered: true });
    // SCRIPT FINGERPRINT

    // CREACION DE IFRAME
    const iframe = this._renderer2.createElement('iframe');
    iframe.name = 'step-up-iframe';
    iframe.height = this.iframeChallengeHeight.toString();
    iframe.width = this.iframeChallengeWidth;
    
    this._renderer2.setStyle(iframe, 'backgroundColor', '#ffffff');

    // CREACION DE FORMULARIO
    const form = document.createElement('form');
    form.id = 'step-up-iframe';
    form.target = 'step-up-iframe';
    form.method = 'POST';
    form.action = stepUpUrl;

    //CREACION DE INPUT JWT
    const input = this._renderer2.createElement('input');
    input.name = 'JWT';
    input.type = 'hidden';
    input.value = jwtAuth;

    this._renderer2.appendChild(form, input);
    this.cdr.detectChanges();
    const container = this.element.nativeElement.querySelector(
      '#div-autentications'
    );

    this._renderer2.appendChild(container, iframe);
    this._renderer2.appendChild(container, form);
    form.submit();
    this._loaderService.unBlockLoaging();
    $('#modalIframeAuth').modal('show');
    //ENVIA EL FORMULARIO UNA VEZ INMEDIATAMENTE DESPUES DE RENDERIZAR

    // Timeout de 5 minutos para verificar la transacción si no hay confirmación
    this.confirmed = false;
    setTimeout(() => {
      if (!this.confirmed) {
        this.continuePaymentAuth();
      }
    }, 300000);
  }

  public continuePaymentAuth() {
    this.confirmed = true;
    $('#modalIframeAuth').modal('hide');
    const bodyRequest = this._paymentService.bodyrequestcard;
    bodyRequest.idSession = this.idSessionToken;
    bodyRequest.transientToken = this.transientToken;
    bodyRequest.captureContext = localStorage.getItem('captureContext');
    this._paymentService
      .validateAuthResult(bodyRequest)
      .subscribe((transactionSummary) => {
        const { resultCode, result } = transactionSummary;
        this._paymentService.callback.emit(transactionSummary);
      });
  }

  initMicroform() {
    const script = this._renderer2.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = this._paymentService.getMicroformSrc();
    script.integrity = this._paymentService.getMicroformIntegrity();
    script.crossOrigin = 'anonymous';
    script.onload = () => {
      // Obtener colores del tema actual
      const textColor = this.isDarkMode ? '#ffffff' : '#000000';
      const bgColor = this.isDarkMode ? '#2d2d2d' : '#ffffff';
      const borderColor = this.isDarkMode ? '#404040' : '#e6e6e6';

      var customStyles = {
        input: {
          'font-size': '16px',
          'color': textColor,
          'background-color': bgColor,
          'border-color': borderColor,
        },
        ':hover': {
          'font-style': 'italic',
        },
        ':disabled': {
          cursor: 'not-allowed',
        },
        valid: {
          color: 'green',
        },
        invalid: {
          color: 'red',
        },
      };
      const flex = new Flex(localStorage.getItem('captureContext'));
      this.microform = flex.microform({ styles: customStyles });
      const number = this.microform.createField('number', {
        placeholder: this.getLabel('placeholder.cardNumber'),
      });
      const securityCode = this.microform.createField('securityCode', {
        placeholder: this.getLabel('placeholder.cvv'),
      });
      number.load('#cardNumber');
      securityCode.load('#cardSC');
    };
    this._renderer2.appendChild(document.body, script);
  }

  decodeToken(token: string): any {
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken;
    } catch (error) {
      return null;
    }
  }

  formatMaskedValue(maskedValue: string, bin: string): string {
    const firstFourBin = bin.slice(0, 4); // Obtener los primeros 4 dígitos del bin
    const lastDigits = maskedValue.slice(-4); // Obtener los últimos 4 dígitos del maskedValue
    const maskedSection = '*'.repeat(maskedValue.length - 8); // Crear los asteriscos para la sección enmascarada

    return `${firstFourBin}${maskedSection}${lastDigits}`;
  }

  isConfirmationPageActive(): boolean {
    return this.moduleService.getConfirmationPage();
  }

  disableConfirmationPage(): void {
    this.moduleService.setConfirmationPage(false);
  }

  linkDebitValidator(event: any) {
    if (this.onlyLinkAutomaticDebit) {
      event.preventDefault();
    }
  }

  tyc() {
    this._paymentService.numbermodule = -1;
    this._paymentService.tyc = true;
  }

  expireTransaction() {
    if (!this.transactionIsFinalized) {
      this._paymentService.expireTransaction(null).subscribe(
        (transactionSummary) => {
          this._paymentService.setAuthToken('');
          this._paymentService.callback.emit(transactionSummary);
          this._paymentService.requestpayment = transactionSummary;
          window.parent.postMessage(transactionSummary, '*');
          this.router.navigate(['/confirmationpayment']);
        },
        (error) => {
          console.log(error);
          this.router.navigate(['/confirmationpayment']);
        }
      );
    }
  }


  emailDomainValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const email = control.value;
      if (!email) return null; // No validar si el campo está vacío.

      const [localPart, domain] = email.split('@');
      if (!domain) {
        return { invalidEmail: 'El correo debe contener un dominio válido.' };
      }

      // Verificar que no haya puntos consecutivos
      if (domain.includes('..')) {
        return { invalidDomainStructure: 'El dominio no puede contener puntos consecutivos.' };
      }

      // Verificar longitud del dominio completo
      if (domain.length > 50) {
        return { domainTooLong: 'El dominio no debe exceder los 50 caracteres.' };
      }

      // Verificar longitud de cada subdominio y que no estén vacíos
      const subdomains = domain.split('.');
      for (const subdomain of subdomains) {
        if (!subdomain) {
          return { emptySubdomain: 'El dominio contiene subdominios vacíos o puntos consecutivos.' };
        }
        if (subdomain.length > 50) {
          return { subdomainTooLong: `El subdominio "${subdomain}" excede los 50 caracteres permitidos.` };
        }
      }

      return null;
    };
  }

  private initializeDarkMode(): void {
  const storedChannel = localStorage.getItem('channel');
  
  if (storedChannel) {
    this.channel = parseInt(storedChannel, 10);
    this.isDarkMode = this.channel === 6;
  }
}

  // Método para obtener las etiquetas según la clave, idioma y canal actuales
  // Si se envia el canal como 7 se obtienen las etiquetas en español e ingles
  getLabel(key: string): string {
    // Llama al servicio para obtener los textos
    return this.LabelService.getLabel(key, this.currentLanguage, this.channel);
  }


}
